import { chunk } from 'lodash';
import { sampleSize } from 'lodash-es';
import { useEffect, useState } from 'react';
import { Person } from '../queries/types';
import { SortProps, SortableEntity, applySorting } from '../sort';

export interface Row<T> {
  items: T[];
  visible: boolean;
}

export interface UseRowsReturn<T> {
  rows: Row<T>[];
  setVisible: () => void;
}

export interface UseRowsProps<T extends SortableEntity> {
  items: T[];
  visibleRows: string;
  visibility: 'all' | 'row';
  sort: SortProps;
}

export function randomizePeopleBySlots(people: Person[][]) {
  const result: Person[] = [];

  people.forEach((personGroup) => {
    result.push(...sampleSize(personGroup, 2));
  });

  return result;
}

export function useRows<T extends SortableEntity>(
  props: UseRowsProps<T>,
): UseRowsReturn<T> {
  const [rows, setRows] = useState<Row<T>[]>([]);

  function setVisible() {
    setRows(
      rows.map((row) => {
        row.visible = true;
        return row;
      }),
    );
  }

  useEffect(() => {
    const sortedItems = applySorting(props.items, props.sort);

    const rows =
      sortedItems.length <= 4
        ? [
            {
              items: sortedItems,
              visible: true,
            },
          ]
        : chunk(sortedItems, 4).map((chunk, index) => {
            return {
              items: chunk,
              visible:
                index < Number(props.visibleRows) || props.visibility === 'all',
            };
          });

    setRows(rows);
  }, []);

  return { rows, setVisible };
}
